import api from './api';
import { DailySummaryResponse, BarberPerformanceResponse, ClientServiceDetailResponse } from '../types/report.types';

export const reportService = {
    getSummary: async (startDate: string, endDate: string): Promise<DailySummaryResponse> => {
        const response = await api.get<DailySummaryResponse>(`/reports/summary?startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    },

    getBarberPerformance: async (startDate: string, endDate: string): Promise<BarberPerformanceResponse[]> => {
        const response = await api.get<BarberPerformanceResponse[]>(`/reports/barbers/performance?startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    },

    getBarberClientsForDate: async (barberId: number, date: string): Promise<ClientServiceDetailResponse[]> => {
        const response = await api.get<ClientServiceDetailResponse[]>(`/reports/barbers/${barberId}/clients?date=${date}`);
        return response.data;
    }
};
